import { render, staticRenderFns } from "./tabHBL2.vue?vue&type=template&id=23671926&scoped=true&"
import script from "./tabHBL2.vue?vue&type=script&lang=js&"
export * from "./tabHBL2.vue?vue&type=script&lang=js&"
import style0 from "./tabHBL2.vue?vue&type=style&index=0&id=23671926&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23671926",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23671926')) {
      api.createRecord('23671926', component.options)
    } else {
      api.reload('23671926', component.options)
    }
    module.hot.accept("./tabHBL2.vue?vue&type=template&id=23671926&scoped=true&", function () {
      api.rerender('23671926', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabHBL2.vue"
export default component.exports